import { Injectable } from '@angular/core';
import { EventEmitter } from 'events';

@Injectable({
    providedIn: 'root'
})
export class HideShowService {
    private _show = true;

    get show() {
        return this._show;
    }

    onChange: EventEmitter;
    readonly eventName = 'hide-show';

    constructor() {
        this.onChange = new EventEmitter();
    }

    toggle() {
        this._show = !this._show;
        this.onChange.emit(this.eventName, this._show);
    }
}
